<div class="invitee-logo-wrapper">
  <img
    class="login-logo"
    src="assets/static/inpool__white.svg"
    alt="InPool Logo" />
</div>
<div class="register-form">
  <div class="d-flex justify-content-between mb-4">
    <h1 class="register-form__title mb-2">
      {{ ("job" | i18n) || "Dienst" }}
    </h1>
    <span *ngIf="externalTransferInfo$ | async as externalTransferInfo">
      {{ ("state" | i18n) || "Status" | titlecase }}:
      <b *ngIf="!externalTransferInfo.declined">{{
        ("jobStatusEnum." + externalTransferInfo.jobStatus | i18n) ||
          jobStatusEnum[externalTransferInfo.jobStatus] | titlecase
      }}</b>
      <b *ngIf="externalTransferInfo.declined">{{
        ("declined" | i18n) || "Abgelehnt" | titlecase
      }}</b>
    </span>
  </div>
  <form
    class="register-form__form"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <div *ngIf="externalTransferInfo$ | async as externalTransferInfo">
      <div
        class="jobInfo__date"
        data-cy="job-date">
        <div class="jobInfo__title-bold">
          {{ externalTransferInfo.date | date: "EEEEEE. dd.MM.yyyy" }}
          |&nbsp;
        </div>
        <div class="d-flex gap-4">
          <div
            class="job-list-item__title-small"
            *ngFor="let shift of externalTransferInfo.shifts; let i = index">
            {{ i > 0 ? "/" : "" }}
            {{ shift.from | time }} - {{ shift.to | time }}
          </div>
          <div>Uhr</div>
        </div>
      </div>
      <div class="mb-2">
        {{ externalTransferInfo.departmentDisplayName }}
      </div>
      <div
        class="mb-2"
        data-cy="required-employees">
        {{ ("requiredEmployees" | i18n) || "Benötigte Mitarbeiter" }}:
        {{ externalTransferInfo.requiredUsers }}
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.caseNumber"
        data-cy="case-number">
        {{ ("caseNumber" | i18n) || "Fallnummer" | titlecase }}:
        {{ externalTransferInfo.caseNumber }}
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.costCenter"
        data-cy="cost-center">
        {{ ("costCenter" | i18n) || "Kostenstelle" | titlecase }}:
        {{ externalTransferInfo.costCenter }}
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.orderId"
        data-cy="order-id">
        {{ ("orderId" | i18n) || "Auftragsnummer" | titlecase }}:
        {{ externalTransferInfo.orderId }}
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.description"
        data-cy="description">
        {{ ("description" | i18n) || "Beschreibung" | titlecase }}:
        {{ externalTransferInfo.description }}
      </div>
      <div
        class="mb-2"
        *ngIf="
          externalTransferInfo.sex ||
          externalTransferInfo.sex === sexEnum.FEMALE
        "
        data-cy="sex">
        {{ ("sex" | i18n) || "Geschlecht" | titlecase }}:
        <span *ngIf="externalTransferInfo.sex === sexEnum.FEMALE">
          {{ ("femaleSex" | i18n) || "Female" }}
        </span>
        <span *ngIf="externalTransferInfo.sex === sexEnum.MALE">
          {{ ("maleSex" | i18n) || "Male" }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.certificates?.length"
        data-cy="certificates">
        {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}:
        <span *ngFor="let certificate of externalTransferInfo.certificates">
          <br />
          {{ certificate.displayName }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="externalTransferInfo.specialities?.length"
        data-cy="specialities">
        {{ ("careSector" | i18n) || "Erfahrung / Pflegebereich" | titlecase }}:
        <span *ngFor="let speciality of externalTransferInfo.specialities">
          <br />
          {{ speciality.displayName }}
        </span>
      </div>
      <div
        class="mb-2"
        *ngIf="
          externalTransferInfo.language ||
          externalTransferInfo.language === languageEnum.DEUTSCH
        "
        data-cy="language">
        {{ ("language" | i18n) || "Sprache" | titlecase }}:
        {{
          ("languageEnum." + externalTransferInfo.language | i18n) ||
            languageEnum[externalTransferInfo.language]
        }}
      </div>
      <div
        class="mb-2"
        *ngIf="
          externalTransferInfo.car ||
          externalTransferInfo.car === carLicenseEnum.LICENSE_AVAILABLE
        "
        data-cy="car">
        {{ ("mobility" | i18n) || "Mobility" | titlecase }}:
        {{
          ("carLicenseEnum." + externalTransferInfo.car | i18n) ||
            carLicenseEnum[externalTransferInfo.car]
        }}
      </div>
      <div class="mt-5">
        <h3>
          {{ ("employees" | i18n) || "Mitarbeiter" | titlecase }}
        </h3>

        <ng-container
          *ngIf="
            transferInviteesExcludingPreviouslyPossible(externalTransferInfo)
              .length > 0
          ">
          <div
            class="d-flex justify-content-between align-items-center requested-users">
            <span>
              {{ ("name" | i18n) || "Name" | titlecase }}
            </span>
            <span>{{ ("state" | i18n) || "Status" | titlecase }}</span>
          </div>
          <div
            *ngFor="
              let invitee of transferInviteesExcludingPreviouslyPossible(
                externalTransferInfo
              )
            "
            class="invitee"
            [attr.data-cy]="'invitee-fullName-' + invitee.fullName">
            <span>{{ invitee.fullName }}</span>
            <div class="d-flex align-items-center">
              <mat-icon
                [svgIcon]="getInviteeIcon(invitee)"
                [class]="getIconClass(invitee)"></mat-icon>

              <span
                class="ms-2"
                *ngIf="invitee.status === inviteeStatusEnum.POSSIBLE_CANDIDATE"
                >{{ ("submitted" | i18n) || "Eingereicht" | titlecase }}</span
              >

              <span
                class="ms-2"
                *ngIf="
                  invitee.status !== inviteeStatusEnum.POSSIBLE_CANDIDATE
                "
                >{{
                  ("inviteeStatusEnum." + invitee.status | i18n) ||
                    inviteeStatusEnum[invitee.status] | titlecase
                }}</span
              >
            </div>
          </div>
        </ng-container>
        <div
          *ngIf="
            transferInviteesExcludingPreviouslyPossible(externalTransferInfo)
              .length === 0 &&
            previouslyPossibleTransferInvitees(externalTransferInfo).length ===
              0
          ">
          {{
            ("noEmployeesSubmitted" | i18n) || "Keine Mitarbeiter eingereicht"
          }}
        </div>

        <ng-container
          *ngIf="
            previouslyPossibleTransferInvitees(externalTransferInfo).length >
              0 && externalTransferInfo.jobStatus === jobStatusEnum.OPEN
          ">
          <h4 class="mt-4 mb-2">
            {{
              ("previouslyPossibleEmployeesSection" | i18n) ||
                "Erneut einreichbare Mitarbeitende"
            }}
          </h4>
          <p class="text-muted small mb-3">
            {{
              ("previouslyPossibleEmployeesHint" | i18n) ||
                "Nach erneuter Ausschreibung können diese Mitarbeitenden wieder eingereicht werden."
            }}
          </p>
          <div
            *ngFor="
              let invitee of previouslyPossibleTransferInvitees(
                externalTransferInfo
              )
            "
            class="invitee d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2"
            [attr.data-cy]="
              'previously-possible-initee-' + invitee.fullName
            ">
            <div class="d-flex align-items-center">
              <mat-icon
                [svgIcon]="getInviteeIcon(invitee)"
                [class]="getIconClass(invitee)"></mat-icon>
              <span class="ms-2">{{ invitee.fullName }}</span>
            </div>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              data-cy="resubmit-previously-possible-invitee"
              (click)="startResubmitFromPreviouslyPossible(invitee)">
              {{
                ("resubmitPreviouslyPossibleEmployee" | i18n) ||
                  "Erneut einreichen"
              }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="showForm$ | async">
          <div
            #submitEmployeeSection
            class="pt-5"
            *ngIf="
              externalTransferInfo &&
              externalTransferInfo.jobStatus === jobStatusEnum.OPEN
            ">
            <h1 class="register-form__title mb-2">
              {{ ("submitEmployees" | i18n) || "Mitarbeiter einreichenn" }}
            </h1>

            <mat-form-field>
              <mat-label>{{ ("sex" | i18n) || "sex" | titlecase }}</mat-label>
              <mat-select
                required
                autofocus
                formControlName="sex">
                <mat-option [value]="sexEnum.FEMALE">{{
                  ("femaleSex" | i18n) || "female" | titlecase
                }}</mat-option>
                <mat-option [value]="sexEnum.MALE">{{
                  ("maleSex" | i18n) || "male" | titlecase
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>{{ ("firstName" | i18n) || "Vorname" }}</mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    formControlName="firstName"
                    autocomplete="given-name" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>{{ ("lastName" | i18n) || "Nachname" }}</mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    formControlName="lastName"
                    autocomplete="family-name" />
                </mat-form-field>
              </div>
            </div>
            <mat-form-field>
              <mat-label>{{ ("email" | i18n) || "E-Mail" }}</mat-label>
              <input
                required
                matInput
                type="email"
                formControlName="email"
                autocomplete="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{
                ("phoneNumber" | i18n) || "phone number" | titlecase
              }}</mat-label>
              <input
                required
                matInput
                placeholder="+41791234567"
                type="phone"
                formControlName="phone"
                (keydown)="trimPhone()"
                autocomplete="tel" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{
                ("pricePerHourIfNotSpecified" | i18n) || "Price per hour"
                  | titlecase
              }}</mat-label>
              <input
                matInput
                type="text"
                pattern="^\d*\.?\d{0,2}$"
                step="0.01"
                min="0"
                placeholder="25.00"
                formControlName="pricePerHour" />
              <span matSuffix>CHF</span>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{
                ("dateOfBirth" | i18n) || "Geburtstag" | titlecase
              }}</mat-label>
              <input
                matInput
                [value]="
                  (dateOfBirth$ | async) ? (dateOfBirth$ | async | date) : ''
                "
                readonly
                [attr.required]="
                  externalTransferInfo?.requiredFields?.dateOfBirth || false
                "
                (click)="dateOfBirthDatePicker.open()" />
              <input
                matInput
                name="user-date-of-birth-datepicker"
                (dateChange)="selectDateOfBirth($event)"
                (click)="dateOfBirthDatePicker.open()"
                (keydown)="(false)"
                [matDatepicker]="dateOfBirthDatePicker"
                hidden />
              <mat-datepicker-toggle
                matSuffix
                [for]="dateOfBirthDatePicker"></mat-datepicker-toggle>
              <button
                *ngIf="
                  (dateOfBirth$ | async) &&
                  !externalTransferInfo?.requiredFields?.dateOfBirth
                "
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearDateOfBirth()">
                <mat-icon svgIcon="close"></mat-icon>
              </button>
              <mat-datepicker #dateOfBirthDatePicker></mat-datepicker>
            </mat-form-field>
            <app-certificate-select
              [required]="
                externalTransferInfo?.requiredFields?.certificates || false
              "
              [selectedMappedCertificates]="
                form?.controls?.certificates?.value || []
              "
              (selectionChanged)="
                certificateSelectionChanged($event)
              "></app-certificate-select>
            <app-speciality-select
              [selectedMappedSpecialities]="
                form?.controls?.specialities?.value || []
              "
              (selectionChanged)="
                specialitySelectionChanged($event)
              "></app-speciality-select>
            <br />
            <mat-form-field>
              <mat-label>{{
                ("additionalAvailabilityInfo" | i18n) ||
                  "Zusatzinformationen zur Verfügbarkeit"
              }}</mat-label>
              <textarea
                [placeholder]="
                  ('additionalAvailabilityInfoPlaceholder' | i18n) ||
                  'z.B. nur bis 22:00 Uhr verfügbar'
                "
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="50"
                formControlName="additionalInfo"></textarea>
            </mat-form-field>
            <ng-container *ngIf="externalTransferInfo.enableFiles">
              <app-upload-file
                *ngIf="!(files$ | async)?.length"
                [isUploading]="!!(isUploading$ | async)"
                (inputEvent)="uploadFile($event)"></app-upload-file>

              <div
                *ngIf="
                  !(isUploading$ | async) &&
                  !(isDownloading$ | async) &&
                  (files$ | async)?.length
                ">
                <ng-container>
                  <div *ngIf="(files$ | async)?.length">
                    <div
                      class="file-list-item"
                      *ngFor="let file of files$ | async">
                      <button
                        type="button"
                        mat-button
                        (click)="downloadInviteeFile($event, file)">
                        <mat-icon svgIcon="download"></mat-icon>
                        <span>{{ file.fileName }} </span>

                        <mat-icon
                          *ngIf="(progressbarValue$ | async) === 100"
                          class="color-success mat-button-small-icon"
                          svgIcon="check-circle"></mat-icon>
                      </button>
                      <small
                        >{{
                          $any(file.size) / (1024 * 1024) | number: "1.0-3"
                        }}
                        MB / {{ file.type | uppercase }} /
                        {{ file.updatedAt | date: "short" }}
                      </small>
                      <button
                        type="button"
                        mat-button
                        class="file-list-item__delete-button"
                        (click)="removeFileDialog(file, deleteConfirm)">
                        <mat-icon svgIcon="close"></mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
              <mat-progress-bar
                *ngIf="isDownloading$ | async"
                mode="determinate"
                [value]="progressbarValue$ | async"></mat-progress-bar>
            </ng-container>
          </div>
        </ng-container>

        <br />
        <div class="row action-button">
          <div
            class="col col-6"
            *ngIf="
              externalTransferInfo.jobStatus === jobStatusEnum.OPEN &&
              !(canNotDeclineJob$ | async)
            ">
            <button
              mat-button
              color="warn"
              type="button"
              (click)="declineTransfer()"
              data-cy="decline-job"
              data-gtm-label="Dienst ablehnen">
              {{ ("declineJob" | i18n) || "decline job" | uppercase }}
            </button>
          </div>
          <div class="col col-6">
            <button
              *ngIf="
                (showForm$ | async) &&
                externalTransferInfo.jobStatus === jobStatusEnum.OPEN
              "
              mat-button
              color="primary"
              type="submit"
              class="mat-button-block"
              [class.disabled]="
                form?.invalid ||
                (externalTransferInfo.enableFiles &&
                  !(files$ | async)?.length) ||
                (externalTransferInfo.requiredFields?.certificates &&
                  !form?.controls?.certificates?.value?.length) ||
                (externalTransferInfo.requiredFields?.sex &&
                  (form?.controls?.sex?.value === undefined ||
                    form?.controls?.sex?.value === null)) ||
                (externalTransferInfo.requiredFields?.dateOfBirth &&
                  !(dateOfBirth$ | async))
              "
              [disabled]="
                form?.invalid ||
                (externalTransferInfo.enableFiles &&
                  !(files$ | async)?.length) ||
                (externalTransferInfo.requiredFields?.certificates &&
                  !form?.controls?.certificates?.value?.length) ||
                (externalTransferInfo.requiredFields?.sex &&
                  (form?.controls?.sex?.value === undefined ||
                    form?.controls?.sex?.value === null)) ||
                (externalTransferInfo.requiredFields?.dateOfBirth &&
                  !(dateOfBirth$ | async)) ||
                false
              ">
              <span>
                {{ ("submit" | i18n) || "einreichen" | uppercase }}
              </span>
            </button>
            <button
              *ngIf="
                !(showForm$ | async) &&
                externalTransferInfo.jobStatus === jobStatusEnum.OPEN
              "
              mat-button
              color="primary"
              class="mat-button-block"
              data-cy="open-form-button"
              (click)="showForm$.next(true)">
              <span>
                {{
                  ("submitEmployees" | i18n) || "Mitarbeiter einreichen"
                    | uppercase
                }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!(externalTransferInfo$ | async)">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </form>
</div>

<ng-template #deleteConfirm>
  <h2 mat-dialog-title>
    {{ ("deleteConfirmTitle" | i18n) || "Remove this document?" }}
  </h2>
  <mat-dialog-content>
    {{
      ("deleteConfirmContent" | i18n) ||
        "This will delete this document and cannot be undone"
    }}
    <br /><br />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-flat-button
      mat-dialog-close
      type="button">
      {{ ("cancel" | i18n) || "cancel" | titlecase }}
    </button>
    <button
      mat-flat-button
      color="warn"
      type="button"
      [mat-dialog-close]="true">
      {{ ("remove" | i18n) || "remove" | titlecase }}
    </button>
  </mat-dialog-actions>
</ng-template>
